import styled from 'styled-components';
import Button from '../Button/Button';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const TextEditorContainer = styled.div`
  .ql-container {
    min-height: 10rem;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;

    &.ql-disabled {
      border: none;
    }
  }

  .ql-editor {
    height: 100%;
    flex: 1;
    overflow-y: auto;
    width: 100%;
  }

  &[aria-invalid='true'] {
    border: 1px solid ${COLORS.STATUS_ERROR};

    .ql-toolbar {
      border: none;
      border-bottom: 1px solid ${COLORS.STATUS_ERROR};
    }

    .ql-container {
      border-color: transparent;
    }
  }

  &:has(.ql-disabled) {
    border: 1px dashed ${COLORS.GRAY_3};
    color: ${COLORS.GRAY_2};
    background: ${COLORS.GRAY_1};
    cursor: disabled;

    .ql-toolbar {
      border: none;
      border-bottom: 1px solid ${COLORS.GRAY_3};
    }
  }
`;

export const StyledButtons = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledButton = styled(Button)`
  margin-left: 10px;
`;

export const StyledLabel = styled.div`
  display: flex;
  align-items: center;
  ${pickThemeFontStyles('12', '14', 'NORMAL')};
  margin-bottom: 0.5rem;

  &&& button {
    margin-left: 0.25rem;
  }
`;

export const StyledTextAreaWrap = styled.div`
  display: flex;
  flex-direction: column;
`;
